import { ThietKe3DApp, ThietKe3DData } from '../types';
import { API_EDU_PREFIX } from '@/config';
import { apiFetch, refreshCreditBalance } from '@/services/apiService';

const PREFIX = `${API_EDU_PREFIX}/thiet-ke-3d`;
const GENERATE_PREFIX = `${API_EDU_PREFIX}/generate`;

const parseJsonOrThrow = async <T>(res: Response): Promise<T> => {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error((data as { message?: string }).message || 'Yêu cầu thất bại');
  }
  return data as T;
};

export const getApps = async (): Promise<ThietKe3DApp[]> => {
  const res = await apiFetch(PREFIX);
  return parseJsonOrThrow<ThietKe3DApp[]>(res);
};

export const getApp = async (id: number | string): Promise<ThietKe3DApp> => {
  const res = await apiFetch(`${PREFIX}/${id}`);
  return parseJsonOrThrow<ThietKe3DApp>(res);
};

export const generateDetailDescription = async (topic: string): Promise<{ data: { description: string } }> => {
  const res = await apiFetch(`${GENERATE_PREFIX}/thiet-ke-3d-detail`, {
    method: 'POST',
    body: JSON.stringify({ topic }),
  });
  const out = await parseJsonOrThrow<{ data: { description: string } }>(res);
  await refreshCreditBalance('thiet-ke-3d-desc');
  return out;
};

export const generate3DData = async (payload: {
  topic: string;
  detailedDescription?: string;
  contentSource?: string;
}): Promise<ThietKe3DApp & { message?: string }> => {
  const res = await apiFetch(`${GENERATE_PREFIX}/thiet-ke-3d-data`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
  const out = await parseJsonOrThrow<ThietKe3DApp & { message?: string }>(res);
  await refreshCreditBalance('thiet-ke-3d-data');
  return out;
};

export const updateApp = async (id: number | string, data: Partial<ThietKe3DApp>): Promise<ThietKe3DApp> => {
  const res = await apiFetch(`${PREFIX}/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(data),
  });
  return parseJsonOrThrow<ThietKe3DApp>(res);
};

export const deleteApp = async (id: number | string): Promise<void> => {
  await apiFetch(`${PREFIX}/${id}`, {
    method: 'DELETE',
  });
};

export const generateHtml5 = async (
  id: number | string
): Promise<{
  message: string;
  status: string;
  validation_pending?: boolean;
  html_url?: string;
  share_token?: string;
  public_html5_url?: string | null;
}> => {
  const res = await apiFetch(`${GENERATE_PREFIX}/thiet-ke-3d/${id}/generate-html5`, {
    method: 'POST',
  });
  const out = await parseJsonOrThrow<{
    message: string;
    status: string;
    validation_pending?: boolean;
    html_url?: string;
    share_token?: string;
    public_html5_url?: string | null;
  }>(res);
  await refreshCreditBalance('thiet-ke-3d-html5');
  return out;
};

/** Kiểm tra / tối ưu runtime sau khi generate-html5 đã lưu file; gọi trước khi mở tab xem. */
export const finalizeHtml5 = async (
  id: number | string
): Promise<{
  message: string;
  status: string;
  html_url?: string;
  share_token?: string;
  public_html5_url?: string | null;
  html5FileSize?: number;
}> => {
  const res = await apiFetch(`${GENERATE_PREFIX}/thiet-ke-3d/${id}/finalize-html5`, {
    method: 'POST',
  });
  return parseJsonOrThrow<{
    message: string;
    status: string;
    html_url?: string;
    share_token?: string;
    public_html5_url?: string | null;
    html5FileSize?: number;
  }>(res);
};
